/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Pending Not Released

1 = Pending

2 = Declined

3 = Approved

4 = Approved

5 = Declined

6 = Expired

7 = Draft

8 = Draft Pending Signature

-2 = Approved Not Released

-1 = Declined Not Released


 */
export type ProposalStatus =
  (typeof ProposalStatus)[keyof typeof ProposalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProposalStatus = {
  Unreleased: 0,
  Pending: 1,
  Declined: 2,
  Approved: 3,
  ManualApprove: 4,
  ManualDecline: 5,
  Expired: 6,
  Draft: 7,
  DraftPendingSignature: 8,
  ApprovedUnreleased: -2,
  DeclinedUnreleased: -1,
} as const;
